import { Controller } from "stimulus";
// TODO split logics into different controllers in order to avoid complicated/multi-purpose controllers
export default class extends Controller {

  scrollTop() {
    var element = event.currentTarget;
    window.scrollTo({top: window.pageYOffset + element.getBoundingClientRect().top - 100, behavior: 'smooth'});
  }
}
